import Box from '@app/components/common/Box';
import TTLogo from '@app/components/common/TTLogo.tsx';
import Typography from '@app/components/common/Typography';
import { m } from 'framer-motion';
import { organizationCardStyles } from './styles';

interface IOrganizationCard {
  id?: number;
  index?: number;
  image?: string;
  name?: string;
  onClick: () => void;
  isActive?: boolean;
}

const OrganizationCard = ({
  id,
  index,
  name,
  image,
  onClick,
  isActive = true,
}: IOrganizationCard) => {
  const opacity = isActive ? 1 : 0.33;
  return id && index ? (
    <m.div
      whileHover={{ scale: 1.02, opacity }}
      whileTap={{ scale: 1 }}
      initial={{ opacity: 0 }}
      animate={{
        opacity,
        transition: { delay: index * 0.1 },
      }}
      css={organizationCardStyles}
      onClick={() => onClick()}>
      <Box className="logo">
        {image ? <img draggable={false} src={image} /> : <TTLogo />}
      </Box>
      <Box className="organizationName">
        <Typography variant="subtitle" fontWeight="medium" color="textWhite">
          {name}
        </Typography>
      </Box>
    </m.div>
  ) : null;
};

export default OrganizationCard;
